import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";
import ReactQuill from "react-quill";
import { isMobile } from "../../globalStyles/mobile";

const EmailTemplateDetailsModal = ({ template, open, onClose }) => {
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <DialogTitle>{"Email Template  Details"}</DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <CustomTypography
                color="var(--text-heading)"
                fontSize="14px"
                fontWeight={400}
              >
                Template Name
              </CustomTypography>
              <TextField
                type="text"
                size="small"
                margin="dense"
                value={template?.name || ""}
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#707070",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Template Subject
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={template?.subject || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#707070",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Template Content
              </CustomTypography>
              <ReactQuill
                theme="snow"
                value={template?.content || ""}
                readOnly={true}
                modules={{ toolbar: false }}
                style={{
                  maxHeight: isMobile() ? 70 : "200px",
                  marginTop: 10,
                }}
              />
              <style>
                {`
          .ql-container {
            background-color: var(--bg-input) !important;
            height: 100%; 
            color:var(--text-secondary) !important
          }
          .ql-editor {
            min-height: 100%; 
            background-color: var(--bg-input) !important; 
            padding: 10px; 
            border-radius: 8px;
            color:var(--text-secondary) !important
          }
        `}
              </style>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 10 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default EmailTemplateDetailsModal;
